var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9494 16.9504C8.68342 16.9504 10.8998 14.734 10.8998 12C10.8998 9.26598 8.68342 7.04962 5.9494 7.04962C3.21538 7.04962 0.999023 9.26598 0.999023 12C0.999023 14.734 3.21538 16.9504 5.9494 16.9504Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8497 16.9504C17.3686 16.9504 18.5999 14.734 18.5999 12C18.5999 9.26598 17.3686 7.04962 15.8497 7.04962C14.3308 7.04962 13.0995 9.26598 13.0995 12C13.0995 14.734 14.3308 16.9504 15.8497 16.9504Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9006 16.9504C22.5082 16.9504 23.0007 14.734 23.0007 12C23.0007 9.26598 22.5082 7.04962 21.9006 7.04962C21.2931 7.04962 20.8005 9.26598 20.8005 12C20.8005 14.734 21.2931 16.9504 21.9006 16.9504Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.54c5a7791461eac9cb7f2ab4c9807e96.svg";
export { ForwardRef as ReactComponent };